import React, { useState, useEffect } from "react";
import Trending from "./Trending.jsx";
import { Container } from "react-bootstrap";
import Spinner from "../utilities/Spinner.jsx";
import useFetch from "../hooks/useFetch";

function TrendingList() {
  const [trendingData, setTrending] = useState(null);
  
  const [data, setData] = useState(null);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const allEvents = useFetch("events/");

  useEffect(() => {
    const trendingEvents = allEvents?.filter((event) => {
      return event.gallery.some((gallery) => Number(gallery.event_type) === 1);
    });


   
    setTrending(trendingEvents);
  }, [allEvents, data]);
  console.log(trendingData);
  return (
    <Container>
      {trendingData === null ? <Spinner /> : <Trending data={trendingData} />}
    </Container>
  );
}

export default TrendingList;
